import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Label } from '@/common/components/Label/Label';
import { getOperationDescription } from '@/common/components/OperationsList/OperationsList.utils';
import { Stack } from '@/common/components/Stack/Stack';
import { IOperation } from '@/common/integrations/menhir/employee/operations/operations.types';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

interface IOperationSummaryDetailProps {
  icon?: ReactNode;
  operation: IOperation;
}

export const OperationSummaryDetail = ({
  icon,
  operation,
}: IOperationSummaryDetailProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Stack justify="between" grow horizontal>
      <Stack gap="md">
        {icon}
        <Label>{getOperationDescription(operation, { t, i18n })}</Label>
      </Stack>
      <BodyText
        bold={operation.status !== 'rejected'}
        strikethrough={operation.status === 'rejected'}
      >
        {MoneyUtils.moneyToString(operation.amount)}
      </BodyText>
    </Stack>
  );
};
